import { useNavigate } from 'react-router-dom'

const styles = `
body{
    margin:0;
    font-family:'Open Sans',sans-serif;
    background:#f7f8fc;
}

.destination-hero{
    background:#1a2e6e;
    color:white;
    padding:80px 20px;
}

.destination-container{
    max-width:1100px;
    margin:auto;
}

.destination-hero h1{
    font-size:46px;
    margin-bottom:15px;
    font-family:'Nunito',sans-serif;
}

.destination-hero p{
    font-size:18px;
    max-width:720px;
    opacity:.95;
    line-height:1.8;
}

.destination-content{
    max-width:1000px;
    margin:50px auto;
    background:white;
    border-radius:16px;
    padding:45px;
    box-shadow:0 10px 30px rgba(0,0,0,.08);
}

.destination-content h2{
    color:#1a2e6e;
    margin-top:40px;
    margin-bottom:20px;
    font-size:30px;
}

.destination-content h3{
    color:#1a2e6e;
    margin-bottom:15px;
}

.destination-content p{
    line-height:1.9;
    color:#555;
}

.destination-content li{
    margin-bottom:15px;
    line-height:1.8;
}

.highlight{
    background:#eef8f2;
    border-left:6px solid #39b36a;
    padding:25px;
    border-radius:12px;
    margin-top:35px;
}

.process{
    background:#f5f7fb;
    border:1px solid #d8dfef;
    padding:20px;
    border-radius:12px;
    text-align:center;
    font-weight:700;
    color:#1a2e6e;
    margin:25px 0;
}

.back-btn{
    background:#f5a623;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:8px;
    cursor:pointer;
    font-weight:700;
    margin-bottom:30px;
}

.back-btn:hover{
    opacity:.9;
}

@media(max-width:768px){

.destination-hero{
    padding:55px 20px;
}

.destination-hero h1{
    font-size:34px;
}

.destination-content{
    margin:20px;
    padding:25px;
}

}
`

export default function ChinaDestination() {
  const navigate = useNavigate()

  return (
    <>
      <style>{styles}</style>

      <section className="destination-hero">
        <div className="destination-container">
          <button className="back-btn" onClick={() => navigate('/', { state: { scrollTo: 'study-destinations' } })}>
            ← Back
          </button>

          <h1>🇨🇳 China</h1>

          <p>
            With massive state funding, modern campuses, and rapid economic growth,
            <strong> China</strong> has become a premier destination for engineering, technology, computer science, and medical (MBBS) degrees.
          </p>
        </div>
      </section>

      <div className="destination-content">
        <h2>✨ Why Choose China?</h2>

        <ul>
          <li>
            <strong>Generous Scholarship Opportunities:</strong> China offers some of the world's most competitive scholarships including CSC, Provincial, and University
            Scholarships that can cover tuition, accommodation, and monthly living expenses.
          </li>

          <li>
            <strong>Top-Ranked Universities:</strong> Study at globally recognized universities with advanced laboratories, research facilities, and internationally respected
            faculty.
          </li>

          <li>
            <strong>Strong Career Advantages:</strong> Gain exposure to one of the world's largest economies with opportunities in engineering, technology, manufacturing, business,
            and medicine.
          </li>

          <li>
            <strong>Modern Lifestyle & Rich Culture:</strong> Experience ultra-modern cities, high-speed rail, excellent infrastructure, and thousands of years of cultural
            heritage.
          </li>
        </ul>

        <h2>📋 Essential Documents</h2>

        <ul>
          <li>
            <strong>Passport:</strong> Valid passport with at least 12 months of validity.
          </li>

          <li>
            <strong>Academic Certificates & Transcripts:</strong> SSC, HSC, or Bachelor's certificates notarized or authenticated by relevant authorities.
          </li>

          <li>
            <strong>Foreigner Physical Examination Form:</strong> Medical examination completed by an authorized physician.
          </li>

          <li>
            <strong>Police Clearance Certificate (PCC):</strong> Recent police clearance certificate as required by the university or embassy.
          </li>

          <li>
            <strong>Recommendation Letters:</strong> Required for many Master's and PhD programs.
          </li>

          <li>
            <strong>Study Plan / Motivation Letter:</strong> Explaining your academic background, research interests, and future goals.
          </li>
        </ul>

        <h2>🚀 Application & Visa Process</h2>

        <div className="process">Choose University → Admission Letter & JW201/JW202 → Student Visa (X1/X2) → Fly to China 🇨🇳</div>

        <ol>
          <li>
            <strong>Submit Your Application:</strong> Apply to your preferred university together with scholarship documents if applicable.
          </li>

          <li>
            <strong>Receive Admission Letter:</strong> The university issues your Admission Notice and JW201/JW202 Visa Form.
          </li>

          <li>
            <strong>Apply for Student Visa:</strong> Complete the X1/X2 visa application and submit documents to the Chinese Embassy or Visa Application Center.
          </li>

          <li>
            <strong>Travel & Residence Permit:</strong> Arrive in China and convert your X1 visa into a Residence Permit after enrollment.
          </li>
        </ol>

        <div className="highlight">
          <h3>🤝 How StudyBuddy Helps</h3>

          <ul>
            <li>
              <strong>Scholarship Matching:</strong> We identify the best CSC, Provincial, and university scholarships that match your academic profile.
            </li>

            <li>
              <strong>Document Legalization:</strong> Complete guidance for notarization, authentication, physical examination forms, and police clearance documents.
            </li>

            <li>
              <strong>Study Plan Writing:</strong> Professional assistance in preparing compelling Study Plans and Motivation Letters.
            </li>

            <li>
              <strong>Application Submission:</strong> We prepare and submit your university applications accurately and on time.
            </li>

            <li>
              <strong>Visa Processing:</strong> Step-by-step assistance throughout the X1/X2 visa application process.
            </li>

            <li>
              <strong>Pre-Departure Support:</strong> Travel preparation, accommodation guidance, airport pickup advice, and orientation before departure.
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
